// extracted by mini-css-extract-plugin
export default {"button":"NotificationsBtn_button__ELN7n","customBadge":"NotificationsBtn_customBadge__JnIB5"};